import type { Chord } from '@/types/chord';
import type { Move, MoveContext, MoveResult } from '../types';

/** widen it — add color. Adds an add9 if the chord doesn't already have one. */
export const widenIt: Move = {
  id: 'widen-it',
  name: 'widen it',
  theory: 'added color',

  applicable(ctx: MoveContext): boolean {
    const chord = ctx.chords[ctx.index];
    return !!chord && !chord.extensions.add9;
  },

  apply(ctx: MoveContext): MoveResult {
    const chord = ctx.chords[ctx.index];
    const changed: Chord = {
      ...chord,
      extensions: { ...chord.extensions, add9: true },
      key: ctx.key,
      mode: ctx.mode,
    };
    const chords: Chord[] = ctx.chords.map((c, i) => (i === ctx.index ? changed : c));

    return {
      chords,
      changedIds: [changed.id],
      explanation: 'let the second ring against the third.',
      theoryLabel: 'added 9th',
    };
  },
};
